// GENERATED by scripts/generateLayoutDefaults.ts — do not edit.
// JSX-free snapshot of the layout registry's defaults for the v1 → v2
// converter in packages/server; layouts/__tests__/layoutDefaults.test.ts
// keeps it in step with the registry.
import type { Orientation, Style, TranscriptionStyle } from '.'
import type { Layout } from './layout'

export type LayoutDefaults = {
  kind: 'audio' | 'video'
  defaultStyle: Style
  transcriptions: { [key in Orientation]: Partial<TranscriptionStyle> }
}

export const LAYOUT_DEFAULTS: Record<Layout, LayoutDefaults> = {
  avatar: {
    kind: 'audio',
    defaultStyle: {
      background: {
        color: 'primary',
      },
      border: {
        color: 'secondary',
      },
      logo: {
        color: 'secondary',
      },
      waveform: {
        color: 'accent',
      },
      transcription: {
        color: 'secondary',
        fontFamily: 'primary',
        highlightColor: 'accent',
        unPlayedColor: 'secondary',
        unPlayedOpacity: 0.5,
        highlightType: 'last-word',
        fontSize: 60,
        scrollType: 'line-by-line',
        fontWeight: 500,
        linesPerPage: 3,
        lineHeight: 1.5,
        textAlign: 'center',
      },
      title: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      subtitle: {
        color: 'secondary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
      speakerName: {
        color: 'secondary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
      speakerUsername: {
        color: 'secondary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
    },
    transcriptions: {
      square: {},
      portrait: {
        fontSize: 72,
        lineHeight: 1.7,
        linesPerPage: 6,
      },
      landscape: {
        fontSize: 58,
        lineHeight: 1.69,
        linesPerPage: 6,
      },
    },
  },
  bigTitle: {
    kind: 'audio',
    defaultStyle: {
      background: {
        color: 'primary',
      },
      border: {
        color: 'accent',
      },
      logo: {
        color: 'white',
      },
      waveform: {
        color: 'accent',
      },
      subtitle: {
        color: 'secondary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
      title: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      speakerName: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      speakerUsername: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      transcription: {
        highlightColor: 'accent',
        color: 'secondary',
        unPlayedColor: 'secondary',
        unPlayedOpacity: 0.5,
        fontFamily: 'primary',
        highlightType: 'last-word',
        scrollType: 'line-by-line',
        fontSize: 46,
        fontWeight: 500,
        linesPerPage: 3,
        lineHeight: 1.68,
        textAlign: 'left',
      },
    },
    transcriptions: {
      square: {},
      landscape: {
        fontSize: 52,
        lineHeight: 1.7,
        linesPerPage: 3,
      },
      portrait: {
        fontSize: 63,
        lineHeight: 1.88,
        linesPerPage: 6,
      },
    },
  },
  block: {
    kind: 'audio',
    defaultStyle: {
      background: {
        color: 'primary',
      },
      border: {
        color: 'primary',
      },
      logo: {
        color: 'secondary',
      },
      waveform: {
        color: 'accent',
      },
      subtitle: {
        color: 'secondary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
      title: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      speakerName: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      speakerUsername: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      transcription: {
        highlightColor: 'primary',
        highlightBgColor: 'accent',
        color: 'secondary',
        fontFamily: 'primary',
        scrollType: 'line-by-line',
        highlightType: 'last-word-bg',
        fontSize: 66,
        fontWeight: 700,
        linesPerPage: 3,
        lineHeight: 1.46,
        textAlign: 'left',
      },
    },
    transcriptions: {
      square: {},
      portrait: {
        fontSize: 76,
        lineHeight: 1.68,
        linesPerPage: 8,
      },
      landscape: {
        fontSize: 66,
        lineHeight: 1.68,
        linesPerPage: 3,
      },
    },
  },
  chatbox: {
    kind: 'audio',
    defaultStyle: {
      background: {
        color: 'primary',
      },
      border: {
        color: 'secondary',
      },
      logo: {
        color: 'secondary',
      },
      waveform: {
        color: 'accent',
      },
      subtitle: {
        color: 'secondary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
      title: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      speakerName: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      speakerUsername: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      transcription: {
        highlightColor: 'accent',
        color: 'secondary',
        unPlayedColor: 'secondary',
        unPlayedOpacity: 0.5,
        scrollType: 'page-by-page',
        fontFamily: 'primary',
        highlightType: 'last-word',
        fontSize: 50,
        fontWeight: 500,
        linesPerPage: 3,
        lineHeight: 1.6,
        textAlign: 'left',
      },
    },
    transcriptions: {
      square: {},
      landscape: {
        fontSize: 54,
        lineHeight: 1.52,
        linesPerPage: 3,
      },
      portrait: {
        fontSize: 64,
        lineHeight: 1.75,
        linesPerPage: 7,
      },
    },
  },
  edgy: {
    kind: 'audio',
    defaultStyle: {
      background: {
        color: 'accent',
      },
      border: {
        color: 'primary',
      },
      logo: {
        color: 'secondary',
      },
      waveform: {
        color: 'primary',
      },
      subtitle: {
        color: 'primary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
      title: {
        color: 'primary',
        fontFamily: 'primary',
      },
      speakerName: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      speakerUsername: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      transcription: {
        highlightColor: 'accent',
        color: 'secondary',
        fontFamily: 'primary',
        highlightType: 'all-words',
        fontSize: 70,
        scrollType: 'page-by-page',
        fontWeight: 500,
        linesPerPage: 3,
        lineHeight: 1.28,
        textAlign: 'left',
      },
    },
    transcriptions: {
      square: {},
      portrait: {
        fontSize: 110,
        linesPerPage: 9,
        lineHeight: 1,
      },
      landscape: {
        fontSize: 100,
        lineHeight: 1,
        linesPerPage: 7,
      },
    },
  },
  framed: {
    kind: 'audio',
    defaultStyle: {
      background: {
        color: 'accent',
      },
      border: {
        color: 'primary',
      },
      logo: {
        color: 'secondary',
      },
      waveform: {
        color: 'accent',
      },
      subtitle: {
        color: 'secondary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
      title: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      speakerName: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      speakerUsername: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      transcription: {
        highlightColor: 'accent',
        color: 'secondary',
        fontFamily: 'primary',
        scrollType: 'line-by-line',
        highlightType: 'last-word',
        unPlayedColor: 'secondary',
        unPlayedOpacity: 0.5,
        fontSize: 58,
        fontWeight: 400,
        linesPerPage: 3,
        lineHeight: 1.5,
        textAlign: 'left',
      },
    },
    transcriptions: {
      square: {},
      landscape: {
        fontSize: 60,
        lineHeight: 1.6,
        linesPerPage: 3,
      },
      portrait: {
        fontSize: 60,
        lineHeight: 1.8,
        linesPerPage: 9,
      },
    },
  },
  postcard: {
    kind: 'audio',
    defaultStyle: {
      background: {
        color: 'accent',
      },
      border: {
        color: 'primary',
      },
      logo: {
        color: 'primary',
      },
      waveform: {
        color: 'accent',
      },
      subtitle: {
        color: 'secondary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
      title: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      speakerUsername: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      transcription: {
        highlightColor: 'accent',
        color: 'secondary',
        fontFamily: 'primary',
        highlightType: 'last-word',
        unPlayedColor: 'secondary',
        unPlayedOpacity: 0.5,
        fontSize: 62,
        fontWeight: 400,
        scrollType: 'page-by-page',
        linesPerPage: 3,
        lineHeight: 1.14,
        textAlign: 'center',
      },
      date: {
        color: 'secondary',
        fontFamily: 'Red Hat Display',
        opacity: 0.5,
      },
    },
    transcriptions: {
      square: {},
      landscape: {
        fontSize: 73,
        lineHeight: 1.4,
        linesPerPage: 2,
      },
      portrait: {
        fontSize: 80,
        lineHeight: 1.42,
      },
    },
  },
  scriptLarge: {
    kind: 'audio',
    defaultStyle: {
      background: {
        color: 'primary',
      },
      border: {
        color: 'secondary',
      },
      logo: {
        color: 'primary',
      },
      waveform: {
        color: 'accent',
      },
      subtitle: {
        color: 'secondary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
      title: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      speakerUsername: {
        color: 'secondary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
      speakerName: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      transcription: {
        highlightColor: 'primary',
        highlightBgColor: 'accent',
        color: 'secondary',
        scrollType: 'line-by-line',
        fontFamily: 'primary',
        highlightType: 'last-word-bg',
        fontSize: 54,
        fontWeight: 500,
        linesPerPage: 3,
        lineHeight: 1.5,
        textAlign: 'left',
      },
    },
    transcriptions: {
      square: {},
      landscape: {
        fontSize: 60,
        lineHeight: 1.6,
        linesPerPage: 4,
      },
      portrait: {
        fontSize: 74,
        lineHeight: 1.7,
        linesPerPage: 6,
      },
    },
  },
  scriptSmall: {
    kind: 'audio',
    defaultStyle: {
      background: {
        color: 'primary',
      },
      border: {
        color: 'secondary',
      },
      logo: {
        color: 'secondary',
      },
      waveform: {
        color: 'accent',
      },
      subtitle: {
        color: 'secondary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
      title: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      speakerUsername: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      transcription: {
        highlightColor: 'accent',
        color: 'secondary',
        scrollType: 'line-by-line',
        fontFamily: 'primary',
        highlightType: 'last-word',
        fontSize: 51,
        fontWeight: 500,
        linesPerPage: 3,
        lineHeight: 1.7,
        textAlign: 'left',
        unPlayedColor: 'secondary',
        unPlayedOpacity: 0.5,
      },
    },
    transcriptions: {
      square: {},
      landscape: {
        fontSize: 62,
        lineHeight: 1.9,
        linesPerPage: 4,
      },
      portrait: {
        fontSize: 68,
        lineHeight: 2,
        linesPerPage: 7,
      },
    },
  },
  selfPortrait: {
    kind: 'audio',
    defaultStyle: {
      background: {
        color: 'accent',
      },
      border: {
        color: 'primary',
      },
      logo: {
        color: 'secondary',
      },
      waveform: {
        color: 'accent',
      },
      subtitle: {
        color: 'primary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
      title: {
        color: 'primary',
        fontFamily: 'primary',
      },
      speakerUsername: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      transcription: {
        highlightColor: 'accent',
        color: 'primary',
        fontFamily: 'primary',
        highlightBgColor: 'primary',
        unPlayedColor: 'primary',
        unPlayedOpacity: 0.5,
        highlightType: 'last-word-bg',
        fontSize: 59,
        fontWeight: 700,
        scrollType: 'page-by-page',
        linesPerPage: 3,
        lineHeight: 1.3,
        textAlign: 'left',
      },
    },
    transcriptions: {
      square: {},
      landscape: {
        fontSize: 76,
        lineHeight: 1.4,
        linesPerPage: 5,
      },
      portrait: {
        fontSize: 77,
        lineHeight: 1.6,
        linesPerPage: 6,
      },
    },
  },
  captions: {
    kind: 'video',
    defaultStyle: {
      background: {
        color: 'primary',
      },
      border: {
        color: 'secondary',
      },
      logo: {
        color: 'secondary',
      },
      waveform: {
        color: 'accent',
      },
      transcription: {
        color: 'white',
        fontFamily: 'primary',
        highlightColor: 'accent',
        unPlayedColor: 'white',
        unPlayedOpacity: 1,
        highlightType: 'last-word',
        fontSize: 60,
        scrollType: 'line-by-line',
        fontWeight: 500,
        linesPerPage: 1,
        lineHeight: 1.5,
        textAlign: 'center',
      },
      title: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      subtitle: {
        color: 'secondary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
      speakerName: {
        color: 'secondary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
      speakerUsername: {
        color: 'secondary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
    },
    transcriptions: {
      square: {},
      portrait: {
        linesPerPage: 1,
      },
      landscape: {
        linesPerPage: 1,
      },
    },
  },
  meme: {
    kind: 'video',
    defaultStyle: {
      background: {
        color: 'primary',
      },
      border: {
        color: 'secondary',
      },
      logo: {
        color: 'secondary',
      },
      waveform: {
        color: 'accent',
      },
      transcription: {
        color: 'white',
        fontFamily: 'Anton',
        highlightColor: 'accent',
        unPlayedColor: 'white',
        unPlayedOpacity: 1,
        highlightType: 'last-word',
        fontSize: 100,
        scrollType: 'line-by-line',
        fontWeight: 700,
        linesPerPage: 1,
        lineHeight: 1.5,
        textAlign: 'center',
        textStrokeColor: 'black',
        textStrokeWidth: 30,
      },
      title: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      subtitle: {
        color: 'secondary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
      speakerName: {
        color: 'secondary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
      speakerUsername: {
        color: 'secondary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
    },
    transcriptions: {
      square: {},
      portrait: {
        linesPerPage: 1,
      },
      landscape: {
        linesPerPage: 1,
      },
    },
  },
  translucent: {
    kind: 'video',
    defaultStyle: {
      background: {
        color: 'primary',
      },
      border: {
        color: 'secondary',
      },
      logo: {
        color: 'secondary',
      },
      waveform: {
        color: 'accent',
      },
      transcription: {
        color: 'white',
        fontFamily: 'primary',
        highlightColor: 'accent',
        unPlayedColor: 'white',
        unPlayedOpacity: 1,
        highlightType: 'last-word',
        fontSize: 60,
        scrollType: 'line-by-line',
        fontWeight: 500,
        linesPerPage: 1,
        lineHeight: 1.5,
        textAlign: 'center',
      },
      title: {
        color: 'secondary',
        fontFamily: 'primary',
      },
      subtitle: {
        color: 'secondary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
      speakerName: {
        color: 'secondary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
      speakerUsername: {
        color: 'secondary',
        fontFamily: 'primary',
        opacity: 0.5,
      },
    },
    transcriptions: {
      square: {},
      portrait: {
        linesPerPage: 1,
      },
      landscape: {
        linesPerPage: 1,
      },
    },
  },
}
